import { render, staticRenderFns } from "./RecipientActionTable.vue?vue&type=template&id=4284cc15&"
import script from "./RecipientActionTable.vue?vue&type=script&lang=ts&"
export * from "./RecipientActionTable.vue?vue&type=script&lang=ts&"
import style0 from "./RecipientActionTable.vue?vue&type=style&index=0&id=4284cc15&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4284cc15')) {
      api.createRecord('4284cc15', component.options)
    } else {
      api.reload('4284cc15', component.options)
    }
    module.hot.accept("./RecipientActionTable.vue?vue&type=template&id=4284cc15&", function () {
      api.rerender('4284cc15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_ActionTable/RecipientActionTable.vue"
export default component.exports